import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import {
  FaPlus,
  FaFilter,
  FaRedo,
  FaEye,
} from "react-icons/fa";

const LibraryBarCodeManagementTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([
    {
      name: "Book One",
      category: "Fiction",
      author: "Author A",
      publication: "Publisher A",
    },
    {
      name: "Book Two",
      category: "Non-Fiction",
      author: "Author B",
      publication: "Publisher B",
    },
    // Add more rows as needed
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="p-3">
      <h4>Library Bar Code Management</h4>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button variant="primary" className="d-flex align-items-center">
          <FaPlus className="me-2" /> + Add Barcode
        </Button>
        <div className="d-flex align-items-center">
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaFilter
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
        </div>
      </div>
      <Card>
        <Card.Body>
          <div  >
            <Table striped bordered hover 
              style={{ overflow: "auto" }}
            
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Author</th>
                  <th>Publication</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.category}</td>
                    <td>{item.author}</td>
                    <td>{item.publication}</td>
                    <td className="text-center">
                      <Button variant="light" size="sm" className="border-0">
                        <FaEye className="text-info" />
                      </Button>
                    </td>
                  </tr>
                ))}
                {!filteredData.length && (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Showing {filteredData.length} of {data.length} entries
            </span>
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Next />
            </Pagination>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LibraryBarCodeManagementTable;
